import { TypesenseLotDetail } from '@bonhams1793/bonhams-typescript'

import { TypesenseClientInstance } from '../typesenseClient'

export function getTypesenseLotDetails({
  getTypesenseClient,
}: TypesenseClientInstance) {
  return async ({
    id,
  }: GetTypesenseLotDetailsByIDProps): Promise<TypesenseLotDetail | null> => {
    try {
      return await getTypesenseClient()
        .collections<TypesenseLotDetail>('lot-details')
        .documents(id.toString())
        .retrieve()
    } catch {
      return null
    }
  }
}

export type GetTypesenseLotDetailsByIDProps = {
  id: string | number
}
